export const newsMessages = {
  en: {
    map: {
      subtitle:        'Live geographic threat overview',
      lastUpdate:      'Last update',
      loading:         'Loading threat data…',
      liveEvents:      'Live Events',
      topCountries:    'Top Targeted',
      legend:          'Legend',
      typeHack:        'Hack Posts',
      typeNews:        'News',
      typeGroup:       'Hacker Groups',
      legendHackHint:  'Victims',
      legendNewsHint:  'Articles',
      legendGroupHint:   'Groups',
      typeAttack:        'Attack Paths',
      legendAttackHint:  'Attacker → Target',
      legendGlowHint:    'Pulsing = active within last hour',
      statHacks:       'Hack Posts',
      statNews:        'News Items',
      statGroups:      'Group Members',
      statCountries:   'Countries',
      justNow:         'just now',
      minsAgo:         'min ago',
      hoursAgo:        'h ago',
      topGroups:       'Top Hacker Groups',
      collapse:        'Collapse panel',
      expand:          'Expand panel',
    },
    news: {
      // ── Sources / RSS Feeds ───────────────────────────────────────────────
      sources: {
        title: 'RSS Feeds / Sources',
        addBtn: 'Add Feed',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        colId: 'ID',
        colUrl: 'Feed URL',
        colDescription: 'Description',
        dialogCreate: 'Add RSS Feed',
        dialogEdit: 'Edit RSS Feed',
        formUrl: 'Feed URL',
        formDescription: 'Description',
        formDescriptionPlaceholder: 'Short description (optional)',
        urlMissing: 'Please enter a feed URL.',
        saved: 'Saved',
        feedCreated: 'RSS feed created.',
        feedUpdated: 'RSS feed updated.',
        deleted: 'Deleted',
        feedDeleted: 'RSS feed removed.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        loadFailed: 'RSS feeds could not be loaded.',
        confirmDelete: 'Really delete this RSS feed?',
      },

      // ── News Table ────────────────────────────────────────────────────────
      list: {
        title: 'Latest News',
        filtersTitle: 'Filters',
        filterReset: 'Reset filters',
        filterSourceLabel: 'Source',
        filterSourcePlaceholder: 'All sources',
        filterCountryLabel: 'Country',
        filterCountryPlaceholder: 'All countries',
        filterDateLabel: 'Date Range',
        filterDatePlaceholder: 'Start – End',
        colDate: 'Date',
        colCountry: 'Country',
        colSource: 'Source',
        colTitle: 'Title',
        colActions: 'Actions',
        viewTooltip: 'View',
        openTooltip: 'Open source',
        noItems: 'No news available.',
        loadFailed: 'News could not be loaded.',
        // stats panel
        statsDays7:      'Last 7 days',
        statsDays30:     'Last 30 days',
        statsDays90:     'Last 90 days',
        statsDays365:    'Last year',
        statsCountries:  'Top Countries',
        statsSources:    'Top Sources',
        statsOther:      'Other',
        statsUnknown:    'Unknown',
        statsLoadFailed: 'Stats could not be loaded.',
      },

      // ── News Item Detail ──────────────────────────────────────────────────
      detail: {
        pageTitle: 'News',
        backBtn: 'Back',
        openSourceBtn: 'Open Source',
        openArticleBtn: 'Open original article',
        noTitle: 'No Title',
        metaPublished: 'Published',
        metaAuthor: 'Author',
        metaSource: 'Source',
        metaCountry: 'Country',
        metaRegion: 'Region',
        metaCity: 'City',
        legendSummary: 'Summary',
        legendFullContent: 'Full Content',
        loadFailed: 'Loading failed.',
        editBtn: 'Edit',
        editTitle: 'Edit news item',
        editHint: 'Correct the AI-assigned metadata (e.g. wrong country).',
        fieldTitle: 'Title',
        fieldCountry: 'Country',
        fieldRegion: 'Region',
        fieldCity: 'City',
        fieldSummary: 'Summary (HTML)',
        fieldContent: 'Full content (HTML)',
        countryNone: '— None —',
        countryFilter: 'Search country…',
        saved: 'News item updated.',
        saveFailed: 'Could not save changes.',
      },

      // ── Widget: Latest news ───────────────────────────────────────────────
      widget: {
        title: 'Latest {count} Feed Items',
        colDate: 'Date',
        colCountry: 'Country',
        colSource: 'Source',
        colTitle: 'Title',
        noItems: 'No feed items.',
        loadFailed: 'Could not load feed items.',
      },
    },
  },
  de: {
    map: {
      subtitle:        'Live geografische Bedrohungsübersicht',
      lastUpdate:      'Letzte Aktualisierung',
      loading:         'Bedrohungsdaten werden geladen…',
      liveEvents:      'Live Events',
      topCountries:    'Top Ziele',
      legend:          'Legende',
      typeHack:        'Hack Posts',
      typeNews:        'News',
      typeGroup:       'Hacker-Gruppen',
      legendHackHint:  'Opfer',
      legendNewsHint:  'Artikel',
      legendGroupHint:   'Gruppen',
      typeAttack:        'Angriffspfade',
      legendAttackHint:  'Angreifer → Ziel',
      legendGlowHint:    'Pulsierend = aktiv in letzter Stunde',
      statHacks:       'Hack Posts',
      statNews:        'News-Einträge',
      statGroups:      'Gruppenmitglieder',
      statCountries:   'Länder',
      justNow:         'gerade eben',
      minsAgo:         'Min. ago',
      hoursAgo:        'Std. ago',
      topGroups:       'Top Hacker-Gruppen',
      collapse:        'Panel einklappen',
      expand:          'Panel ausklappen',
    },
    news: {
      sources: {
        title: 'RSS Feeds / Quellen',
        addBtn: 'Feed hinzufügen',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        colId: 'ID',
        colUrl: 'Feed URL',
        colDescription: 'Beschreibung',
        dialogCreate: 'RSS Feed hinzufügen',
        dialogEdit: 'RSS Feed bearbeiten',
        formUrl: 'Feed URL',
        formDescription: 'Beschreibung',
        formDescriptionPlaceholder: 'Kurzbeschreibung (optional)',
        urlMissing: 'Bitte eine Feed-URL angeben.',
        saved: 'Gespeichert',
        feedCreated: 'RSS Feed wurde erstellt.',
        feedUpdated: 'RSS Feed wurde aktualisiert.',
        deleted: 'Gelöscht',
        feedDeleted: 'RSS Feed wurde entfernt.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        loadFailed: 'RSS Feeds konnten nicht geladen werden.',
        confirmDelete: 'Möchtest du diesen RSS Feed wirklich löschen?',
      },

      list: {
        title: 'Aktuelle News',
        filtersTitle: 'Filter',
        filterReset: 'Filter zurücksetzen',
        filterSourceLabel: 'Quelle',
        filterSourcePlaceholder: 'Alle Quellen',
        filterCountryLabel: 'Land',
        filterCountryPlaceholder: 'Alle Länder',
        filterDateLabel: 'Zeitraum',
        filterDatePlaceholder: 'Start – Ende',
        colDate: 'Datum',
        colCountry: 'Land',
        colSource: 'Quelle',
        colTitle: 'Titel',
        colActions: 'Aktionen',
        viewTooltip: 'Ansehen',
        openTooltip: 'Quelle öffnen',
        noItems: 'Keine News vorhanden.',
        loadFailed: 'News konnten nicht geladen werden.',
        // stats panel
        statsDays7:      'Letzte 7 Tage',
        statsDays30:     'Letzte 30 Tage',
        statsDays90:     'Letzte 90 Tage',
        statsDays365:    'Letztes Jahr',
        statsCountries:  'Top Länder',
        statsSources:    'Top Quellen',
        statsOther:      'Sonstige',
        statsUnknown:    'Unbekannt',
        statsLoadFailed: 'Statistiken konnten nicht geladen werden.',
      },

      detail: {
        pageTitle: 'News',
        backBtn: 'Zurück',
        openSourceBtn: 'Quelle öffnen',
        openArticleBtn: 'Originalartikel öffnen',
        noTitle: 'Ohne Titel',
        metaPublished: 'Veröffentlicht',
        metaAuthor: 'Autor',
        metaSource: 'Quelle',
        metaCountry: 'Land',
        metaRegion: 'Region',
        metaCity: 'Stadt',
        legendSummary: 'Zusammenfassung',
        legendFullContent: 'Vollständiger Inhalt',
        loadFailed: 'Laden fehlgeschlagen.',
        editBtn: 'Bearbeiten',
        editTitle: 'News-Eintrag bearbeiten',
        editHint: 'Korrigiere die von der KI zugeordneten Metadaten (z. B. falsches Land).',
        fieldTitle: 'Titel',
        fieldCountry: 'Land',
        fieldRegion: 'Region',
        fieldCity: 'Stadt',
        fieldSummary: 'Zusammenfassung (HTML)',
        fieldContent: 'Vollständiger Inhalt (HTML)',
        countryNone: '— Keines —',
        countryFilter: 'Land suchen…',
        saved: 'News-Eintrag aktualisiert.',
        saveFailed: 'Änderungen konnten nicht gespeichert werden.',
      },

      widget: {
        title: 'Letzte {count} Feed-Einträge',
        colDate: 'Datum',
        colCountry: 'Land',
        colSource: 'Quelle',
        colTitle: 'Titel',
        noItems: 'Keine Feed-Einträge.',
        loadFailed: 'Feed-Einträge konnten nicht geladen werden.',
      },
    },
  },
}
